import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuSeparator, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessagesSquare, Newspaper, Zap, Crown, User, CreditCard, LogOut, Clock, Users } from "lucide-react";

export default function BottomNav({ view, setView, isPro, onUpgrade, onManageBilling, onHistory, user, logout }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const item = (active) =>
    `flex flex-col items-center justify-center gap-1 flex-1 py-2.5 text-[11px] font-semibold transition-colors ${
      active ? "text-[#FF5A00]" : "text-[#9ca3af] hover:text-white"
    }`;

  return (
    <nav data-testid="bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      className="shrink-0 border-t border-[#2a3040] bg-[#0a0a0f]/95 backdrop-blur-xl flex items-stretch px-2 relative z-30">
      <button data-testid="bottomnav-chat" className={item(view === "chat")} onClick={() => { closeMenu(); setView("chat"); }}>
        <MessagesSquare size={20} /> Chat
      </button>

      <button data-testid="bottomnav-history" className={item(false)} onClick={() => { closeMenu(); onHistory(); }}>
        <Clock size={20} /> History
      </button>

      <button data-testid="bottomnav-upgrade" className={item(false)} onClick={() => { closeMenu(); isPro ? navigate("/pro") : onUpgrade(); }}>
        {isPro ? <Crown size={20} /> : <Zap size={20} />}
        Pro
      </button>

      <button data-testid="bottomnav-feed" className={item(view === "feed")} onClick={() => { closeMenu(); setView("feed"); }}>
        <Newspaper size={20} /> News
      </button>

      <button data-testid="bottomnav-community" className={item(view === "community")} onClick={() => { closeMenu(); setView("community"); }}>
        <Users size={20} /> Community
      </button>

      <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen} modal={false}>
        <DropdownMenuTrigger asChild>
          <button data-testid="bottomnav-profile" className={item(false)}>
            <User size={20} /> Profile
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="top" align="end"
          className="bg-[#15151d] border-[#2a3040] text-white min-w-[220px] mb-2">
          <DropdownMenuLabel className="flex items-center gap-2.5 py-2">
            <span className="w-9 h-9 rounded-full bg-[#FF5A00] text-[#0a0a0f] font-black flex items-center justify-center shrink-0 font-display">
              {(user?.name || user?.email || "?")[0]?.toUpperCase()}
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-1.5 text-sm text-white truncate">
                {user?.name || "Member"}
                {isPro && (
                  <span className="inline-flex items-center gap-0.5 text-[9px] uppercase tracking-wider bg-[#FF5A00] text-[#0a0a0f] px-1.5 py-0.5 rounded font-bold" data-testid="pro-badge">
                    <Crown size={9} /> Pro
                  </span>
                )}
              </span>
              <span className="block text-xs text-[#6b7280] truncate">{user?.email}</span>
            </span>
          </DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-[#2a3040]" />
          {isPro ? (
            <>
              <DropdownMenuItem data-testid="menu-pro-features" onClick={() => navigate("/pro")}
                className="cursor-pointer focus:bg-[#1a1a24] focus:text-white gap-2">
                <Crown size={15} className="text-[#FF5A00]" /> Your Pro features
              </DropdownMenuItem>
              <DropdownMenuItem data-testid="menu-billing" onClick={onManageBilling}
                className="cursor-pointer focus:bg-[#1a1a24] focus:text-white gap-2">
                <CreditCard size={15} className="text-[#FF5A00]" /> Manage billing
              </DropdownMenuItem>
            </>
          ) : (
            <DropdownMenuItem data-testid="menu-upgrade" onClick={onUpgrade}
              className="cursor-pointer focus:bg-[#1a1a24] focus:text-white gap-2">
              <Zap size={15} className="text-[#FF5A00]" /> Upgrade to Pro
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator className="bg-[#2a3040]" />
          <DropdownMenuItem data-testid="logout-button" onClick={logout}
            className="cursor-pointer focus:bg-[#1a1a24] text-[#f87171] focus:text-[#f87171] gap-2">
            <LogOut size={15} /> Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </nav>
  );
}
